import { getDirectionFromAtoB } from '../../../../../services/utils/getDirectionFromAtoB';

const getStormDirection = (start, end) => `storm-${getDirectionFromAtoB(start, end)}`;

export { getStormDirection };
